import {
  Box,
  BoxProps,
  HStack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { ReactNode, memo } from 'react';
import { FaCheckCircle, FaInfoCircle, FaTimesCircle } from 'react-icons/fa';
import { RiErrorWarningFill } from 'react-icons/ri';

interface IProps extends BoxProps {
  text: ReactNode;
  icon?: ReactNode;
  status?: 'success' | 'warning' | 'danger' | 'info';
}

const Info: React.FC<IProps> = ({
  text,
  icon,
  status = 'info',
  ...props
}): JSX.Element => {
  const statusStyleMap = {
    success: {
      icon: <FaCheckCircle />,
      bg: useColorModeValue('green.50', 'green.900'),
      iconBg: useColorModeValue('green.100', 'green.700'),
      iconColor: 'green.500',
    },
    warning: {
      icon: <RiErrorWarningFill />,
      bg: useColorModeValue('orange.50', 'orange.900'),
      iconBg: useColorModeValue('orange.100', 'orange.700'),
      iconColor: 'orange.400',
    },
    danger: {
      icon: <FaTimesCircle />,
      bg: useColorModeValue('red.50', 'red.900'),
      iconBg: useColorModeValue('red.100', 'red.700'),
      iconColor: 'red.500',
    },
    info: {
      icon: <FaInfoCircle />,
      bg: useColorModeValue('blue.50', 'blue.900'),
      iconBg: useColorModeValue('blue.100', 'blue.700'),
      iconColor: 'blue.400',
    },
  };

  const styles = statusStyleMap[status];

  return (
    <HStack
      rounded="lg"
      bg={styles.bg}
      p="3"
      spacing={3}
      align="center"
      {...props}
    >
      <Box
        p={1.5}
        bg={styles.iconBg}
        rounded="full"
        color={styles.iconColor}
        fontSize="20px"
      >
        {icon || styles.icon}
      </Box>
      <Text color="text.primary">{text}</Text>
    </HStack>
  );
};

export default memo(Info);
